/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import AbstractFieldGroup from './AbstractFieldGroup';

export default class GA extends AbstractFieldGroup {
	fields() {
		return [
			{
				name: 'name',
				type: 'text',
			},
			{
				name: 'creative',
				type: 'text',
			},
			{
				name: 'id',
				type: 'text',
			},
		];
	}
}
